import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ModalDialogDismissOption} from '@shared/confirmation-dialog/modal-dialog-dismiss-option';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {GatewaySignals} from '@models/adminstration/gateway/gateway-configuration/gateway-signals';
import {GatewayArray} from '@models/adminstration/gateway/gateway-configuration/gateway-array';
import {GatewayValues} from '@models/adminstration/gateway/gateway-configuration/gateway-values';
import {NgSelectComponent} from '@ng-select/ng-select';
import {GatewayService} from '@services/administration/gateway/gateway.service';

@Component({
    selector: 'scitis-admin-gateway-arrays-edit',
    templateUrl: './gateway-arrays-edit.component.html',
    styleUrls: ['./gateway-arrays-edit.component.scss'],
    standalone: false
})
export class GatewayArraysEditComponent implements OnInit {

  @Input()
  gatewaySignalsConfig: GatewaySignals = new GatewaySignals();

  @Input()
  gatewayArray: GatewayArray = new GatewayArray();

  @ViewChild('selectValue')
  ngSelectConstant: NgSelectComponent | any;

  gatewayArrayForm: UntypedFormGroup = new UntypedFormGroup({});
  copyGatewayArray: GatewayArray = new GatewayArray();
  dataTypes = ['BOOLEAN', 'FLOAT', 'INTEGER', 'STRING', 'TIMESTAMP'];
  submitted: boolean = false;
  isNewArray: boolean = false;
  valuesForDatatype: GatewayValues[] = [];

  constructor(private activeModal: NgbActiveModal,
              private gatewayService: GatewayService) { }

  ngOnInit(): void {
    this.isNewArray = (!this.gatewayArray);
    this.copyGatewayArray = JSON.parse(JSON.stringify(this.gatewayArray));
    this.generateGatewayArrayForm(this.gatewayArray);

    if(this.copyGatewayArray.datatype === null || this.copyGatewayArray.datatype === undefined || this.copyGatewayArray.datatype === ''){
      this.gatewayArrayForm.get('values')?.disable();
    }

    if(this.copyGatewayArray.values.length > 0){
      this.gatewayArrayForm.get('datatype')?.disable();
      this.setValuesArray();
    }
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.gatewayArrayForm.controls;
  }

  get isDisabledSaveBtn(): boolean {
    return this.submitted ? this.gatewayArrayForm.invalid : this.submitted && this.gatewayArrayForm.invalid;
  };

  onCancel(){
    this.activeModal.dismiss(ModalDialogDismissOption.CANCEL);
  }

  onClose(){
    this.activeModal.dismiss(ModalDialogDismissOption.CLOSE);
  }

  onSave(){
    this.submitted = true;
    // stop here if form is invalid
    if(this.gatewayArrayForm.invalid){
      return;
    }
    this.updateGatewayArrayProperties();
    this.activeModal.close(this.copyGatewayArray);
  }

  onChangeDatatype(event: any){
    this.copyGatewayArray.datatype = event;
    this.gatewayArrayForm.get('values')?.enable();
    this.setValuesArray();
  }

  onChangeValue(event: any){
    this.copyGatewayArray.values.push(event);
    this.ngSelectConstant.itemsList.clearSelected(true);
    if(this.gatewayArrayForm.get('datatype')?.enabled) {
      this.gatewayArrayForm.get('datatype')?.disable();
    }
  }

  onRemoveValue(value: GatewayValues){
    const index: number = this.copyGatewayArray.values.indexOf(value, 0);
    this.copyGatewayArray.values.splice(index, 1);
    if(!this.copyGatewayArray.values || this.copyGatewayArray.values.length <= 0){
      this.gatewayArrayForm.get('datatype')?.enable();
    }
  }

  private generateGatewayArrayForm(gatewayArray: GatewayArray){
    this.gatewayArrayForm = new UntypedFormGroup({
      name: new UntypedFormControl(gatewayArray.name, [Validators.required, this.gatewayService.nameAlreadyUsedValidator(this.gatewaySignalsConfig.arrays)]),
      datatype: new UntypedFormControl(gatewayArray.datatype, [Validators.required]),
      values: new UntypedFormControl(),
    });
  }

    setValuesArray(){
    this.valuesForDatatype = [];
    for(const val of this.gatewaySignalsConfig.values){
      if(val.datatype === this.copyGatewayArray.datatype){
        this.valuesForDatatype = [...this.valuesForDatatype, val];
      }
    }
  }

  private updateGatewayArrayProperties() {
     this.copyGatewayArray.name = this.f.name.value;
     this.copyGatewayArray.datatype = this.f.datatype.value;
  }
}
